// extracted by mini-css-extract-plugin
export default {"compactDownload":"CompactDownloadButton_compactDownload__UBnlN","icon":"CompactDownloadButton_icon__mQDO9"};